import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const residentsList = createAsyncThunk('residents/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `resident_list`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const residents = createSlice({
    name: 'residents',
    initialState: {
        list: [],
        loading: false,
    },
    reducers: {
        removeResidents: (state, action) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(residentsList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(residentsList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(residentsList.rejected, (state, action) => {
            state.loading = false;
        })

    }
})

export const { removeResidents } = residents.actions;
export default residents.reducer;